module.exports = __webpack_public_path__ + "static/media/white-dots.8124a9ca.svg";